import {
  FETCH_RESPONSE,
  FETCH_RESPONSES,
  FETCH_RESPONSES_ITEMS,
  FETCH_RESPONSES_SEARCH,
  FETCH_RESPONSE_ITEM,
  SET_LOADING,
} from './actions/responses'
import { Message } from 'element-ui'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const api = RepositoryFactory.get('responses')
const Organizations = RepositoryFactory.get('organizations')
const TTN = RepositoryFactory.get('ttn')
const Payments = RepositoryFactory.get('payments')
const Doc = RepositoryFactory.get('doc')

export default {
  namespaced: true,
  state: {
    currentList: {
      pages: {},
      currentPage: 0,
      totalCount: 0,
      pageCount: 0,
      perPage: 0,
    },
    flightsList: [],
    flightsTTN: [],
    flightsPay: [],
    flightsAct: [],
    pagination: {},
    flightsExp: [],
    loading: false,
    loadingTTN: false,
    loadingPay: false,
    loadingAct: false,
    loadingExp: false,
  },
  getters: {
    currentPageList: ({ currentList }) =>
      currentList.pages[currentList.currentPage] || [],
    currentPagination: ({
      currentList: { totalCount, pageCount, currentPage, perPage },
    }) => ({ totalCount, pageCount, currentPage, perPage }),
    flightsList: state => state.flightsList,
    getExporters: state => state.flightsExp,
    getFlightById: state => id => state.flightsList.find(p => p.id === id),
    getFlights: state => (id, type) =>
      state['flights' + type].filter(p => p.response_id === id),
    getPagination: state => state.pagination,
    getLoading:
      state =>
      (type = '') =>
        state['loading' + type],
  },
  actions: {
    async fetchResponses({ commit }, page = 1) {
      try {
        commit(SET_LOADING, { flag: true })
        const { data } = await api.fetchResponses(page)

        commit(FETCH_RESPONSES, { ...data, localPage: page })
      } catch (error) {
        Message({
          type: 'error',
          showClose: true,
          message: 'Произошла неизвестная ошибка',
        })
      } finally {
        commit(SET_LOADING, { flag: false })
      }
    },
    getResponsesCount({ commit }) {
      commit(SET_LOADING, { flag: true })
      api
        .getResponsesCount()
        .then(res => commit(FETCH_RESPONSES, { ...res.data }))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false }))
    },
    fetchFlights({ commit, dispatch }, { access, ...reqestData }) {
      commit(SET_LOADING, { flag: true })
      api
        .fetchFlights(reqestData)
        .then(({ data }) => {
          const flights = data.responses
          const pagination = data.responses_meta
          const ids = flights && flights.length ? flights.map(f => f.id) : null

          if (ids) {
            dispatch('fetchFlightsTTN', ids)

            if (access) {
              dispatch('fetchFlightsPay', ids)
            }
            dispatch('fetchFlightsActs', ids)
          }
          commit(FETCH_RESPONSES_SEARCH, { flights, pagination })
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false }))
    },
    fetchFlightsTTN({ commit }, ids) {
      const type = 'TTN'

      commit(SET_LOADING, { flag: true, type })
      TTN.getList(ids)
        .then(res => commit(FETCH_RESPONSES_ITEMS, { data: res.data, type }))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchFlightsPay({ commit }, ids) {
      const type = 'Pay'

      commit(SET_LOADING, { flag: true, type })
      Payments.listById(ids)
        .then(res => commit(FETCH_RESPONSES_ITEMS, { data: res.data, type }))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchFlightsActs({ commit }, ids) {
      const type = 'Act'

      commit(SET_LOADING, { flag: true, type })
      const ActsListPromise = ids.map(id =>
        Doc.getDocument('responses', id, 'works_act'),
      )

      Promise.all(ActsListPromise)
        .then(res => {
          const { data: allActs } = res.reduce(
            (a, b) => ({
              data: [
                ...a.data,
                ...b.data.map(d => ({
                  ...d,
                  response_id: b.config.params.rel_id,
                })),
              ],
            }),
            { data: [] },
          )

          commit(FETCH_RESPONSES_ITEMS, { data: allActs, type })
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchExporters({ commit }) {
      const type = 'Exp'

      commit(SET_LOADING, { flag: true, type })
      Organizations.getExporters()
        .then(res => commit(FETCH_RESPONSES_ITEMS, { data: res.data, type }))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchFlight({ commit, dispatch }, id) {
      const type = 'Pay'

      commit(SET_LOADING, { flag: true, type })
      api
        .fetchFlights({ id })
        .then(({ data }) => {
          const flight = data.responses || null

          if (id) {
            dispatch('fetchFlightPay', id)
          }
          commit(FETCH_RESPONSE, flight)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchFlightTTN({ commit }, id) {
      const type = 'TTN'

      commit(SET_LOADING, { flag: true, type })
      TTN.getList(id)
        .then(res => commit(FETCH_RESPONSE_ITEM, { id, data: res.data, type }))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchFlightAct({ commit }, id) {
      const type = 'Act'

      commit(SET_LOADING, { flag: true, type })
      Doc.getDocument('responses', id, 'works_act')
        .then(res =>
          commit(FETCH_RESPONSE_ITEM, {
            id,
            data: [...res.data.map(d => ({ ...d, response_id: id }))],
            type,
          }),
        )
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    fetchFlightPay({ commit }, id) {
      const type = 'Pay'

      commit(SET_LOADING, { flag: true, type })
      Payments.listById(id)
        .then(res => commit(FETCH_RESPONSE_ITEM, { id, data: res.data, type }))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { flag: false, type }))
    },
    moveResponseToNewDay(context, payload) {
      return api
        .setNewDay(payload)
        .then(() => true)
        .catch(() => false)
    },
  },
  mutations: {
    [SET_LOADING](state, { flag, type = '' }) {
      state['loading' + type] = Boolean(flag)
    },
    updateResponse(state, { id, data }) {
      if (id && data) {
        const index = state.flightsList.findIndex(f => f.id === id)

        if (index >= 0) {
          const newResp = { ...state.flightsList[index] }

          newResp.bid = { ...newResp.bid, ...data }
          state.flightsList.splice(index, 1, newResp)
        }
      }
    },
    [FETCH_RESPONSES](state, payload) {
      if (payload.localPage === payload._meta.currentPage) {
        state.currentList.pages[payload._meta.currentPage] = payload.items
      }
      state.currentList.totalCount = payload._meta.totalCount
      state.currentList.pageCount = payload._meta.pageCount
      state.currentList.currentPage = payload.localPage
      state.currentList.perPage = payload._meta.perPage
    },
    [FETCH_RESPONSES_SEARCH](state, { flights, pagination }) {
      state.flightsList = flights
      state.pagination = pagination
    },
    [FETCH_RESPONSES_ITEMS](state, { data, type }) {
      state['flights' + type] = data
    },
    [FETCH_RESPONSE](state, flight) {
      if (flight && flight.length) {
        const index = state.flightsList.findIndex(f => f.id === flight[0].id)

        if (index >= 0) {
          state.flightsList.splice(index, 1, flight[0])
        }
      }
    },
    [FETCH_RESPONSE_ITEM](state, { id, data, type }) {
      const arr = data
      const key = 'flights' + type

      state[key].map((f, i) => {
        if (f.response_id === id) {
          if (arr && arr.length) {
            const index = arr.findIndex(t => t.id === f.id)

            if (index >= 0) {
              if (!arr[index].response_id) {
                arr[index].response_id = id
              }
              state[key].splice(i, 1, arr[index])
              arr.splice(index, 1)
            }

            return false
          }
          state[key].splice(i, 1)
        }
      })

      if (arr && arr.length) {
        state[key] = state[key].concat(arr)
      }
    },
  },
}
